<template>
  <div class="collect-page">
    <header class="page-header">
      <button
        type="button"
        class="back-btn"
        @click="$router.back()"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('collect.title') }}</h1>
    </header>

    <nav class="collect-tabs">
      <button
        type="button"
        :class="{ active: activeType === 1 }"
        @click="switchType(1)"
      >
        {{ $t('collect.hotel') }}
      </button>
      <button
        type="button"
        :class="{ active: activeType === 2 }"
        @click="switchType(2)"
      >
        {{ $t('collect.shop') }}
      </button>
    </nav>

    <main class="collect-main">
      <section
        v-if="activeType === 1 && hotels.length"
        class="hotel-grid"
      >
        <article
          v-for="item in hotels"
          :key="item.fav_id || item.id"
          class="hotel-card"
          @click="goHotel(item)"
        >
          <img
            :src="hotelImage(item)"
            alt=""
            @error="onHotelImageError"
          >
          <h2>{{ item.title || '--' }}</h2>
          <p>
            <strong>${{ formatPrice(item.price) }}</strong>
            <span>{{ $t('hotelList.sold') }} {{ formatSold(item.sold) }}</span>
          </p>
        </article>
      </section>

      <section
        v-if="activeType === 2 && shops.length"
        class="shop-list"
      >
        <article
          v-for="item in shops"
          :key="item.fav_id || item.id"
          class="shop-card"
          @click="goShop(item)"
        >
          <img
            :src="shopImage(item)"
            alt=""
            @error="onShopImageError"
          >
          <div class="shop-info">
            <h2>{{ item.name || '--' }}</h2>
            <p>
              <span>{{ $t('shopCenter.goodsNum') }} {{ item.goods || 0 }}</span>
              <span>{{ $t('shopCenter.favorites') }} {{ item.fav || 0 }}</span>
            </p>
          </div>
          <van-icon name="arrow" />
        </article>
      </section>

      <div
        v-if="!loading && isEmpty"
        class="empty-state"
      >
        {{ $t('collect.noMore') }}
      </div>
    </main>
  </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch';
import { Icon, Toast } from 'vant';

Vue.use(Icon).use(Toast);

export default {
  name: 'Collect',
  data() {
    return {
      app: {},
      activeType: 1,
      hotels: [],
      shops: [],
      page: 1,
      limit: 50,
      loading: false,
      hotelFallback: require('../images/shop2/pro.png'),
      shopFallback: require('../images/shop2/thumbnail.png'),
    };
  },
  computed: {
    isEmpty() {
      return this.activeType === 1 ? this.hotels.length === 0 : this.shops.length === 0;
    },
  },
  created() {
    if (this.$parent && this.$parent.footer) {
      this.$parent.footer('user', true);
    }
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch('/index/webconfig').then((r) => {
        this.app = r.data || {};
      });
      this.loadList();
    },
    switchType(type) {
      if (this.activeType === type) {
        return;
      }
      this.activeType = type;
      this.page = 1;
      this.loadList();
    },
    loadList() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      Fetch('/user/fav_list', {
        type: this.activeType,
        page: this.page,
        limit: this.limit,
      }, null, true).then((r) => {
        var data = r.data || {};
        var list = Array.isArray(data.list) ? data.list : [];
        if (this.activeType === 1) {
          this.hotels = list;
        } else {
          this.shops = list;
        }
      }).catch(() => {
        Toast(this.$t('collect.noMore'));
      }).finally(() => {
        this.loading = false;
      });
    },
    goHotel(item) {
      var id = Number(item && item.id);
      if (!id) {
        return;
      }
      this.$router.push({
        path: '/hotelit',
        query: {
          id: id,
        },
      });
    },
    goShop(item) {
      var id = Number(item && item.id);
      if (!id) {
        return;
      }
      this.$router.push({
        path: '/hotel',
        query: {
          sid: id,
        },
      });
    },
    buildImageUrl(path, fallback) {
      if (!path) {
        return fallback;
      }
      if (/^(https?:)?\/\//.test(path) || String(path).indexOf('data:') === 0) {
        return path;
      }
      if (this.app && this.app.domain) {
        return this.app.domain.replace(/\/$/, '') + '/' + String(path).replace(/^\//, '');
      }
      return path;
    },
    hotelImage(item) {
      return this.buildImageUrl(item && item.img, this.hotelFallback);
    },
    shopImage(item) {
      return this.buildImageUrl(item && item.img, this.shopFallback);
    },
    onHotelImageError(event) {
      if (event && event.target && event.target.src !== this.hotelFallback) {
        event.target.src = this.hotelFallback;
      }
    },
    onShopImageError(event) {
      if (event && event.target && event.target.src !== this.shopFallback) {
        event.target.src = this.shopFallback;
      }
    },
    formatPrice(value) {
      var number = Number(value);
      if (!isFinite(number)) {
        number = 0;
      }
      return number.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    formatSold(value) {
      var number = Number(value);
      if (!isFinite(number) || number < 0) {
        number = 0;
      }
      if (number === 0) {
        return '0';
      }
      var shortNumber = number / 1000;
      var fixed = shortNumber >= 10 ? shortNumber.toFixed(0) : shortNumber.toFixed(1);
      return fixed.replace(/\.0$/, '') + 'k+';
    },
    kefuTo() {
      if (this.app && this.app.kefu_link) {
        window.location.href = this.app.kefu_link;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.collect-page {
  min-height: 100vh;
  padding-bottom: 72px;
  background: #eaf2fb;
  color: #06152b;
}

.page-header {
  position: sticky;
  top: 0;
  z-index: 12;
  display: grid;
  grid-template-columns: 54px 1fr 54px;
  height: 58px;
  align-items: center;
  background: #f4f5fa;
  border-bottom: 1px solid #e8ebf0;
}

.page-header h1 {
  margin: 0;
  color: #06152b;
  font-size: 14px;
  font-weight: 500;
  line-height: 58px;
  text-align: center;
}

.back-btn {
  display: flex;
  height: 58px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: #06152b;
}

.back-btn .van-icon {
  font-size: 22px;
}

.collect-tabs {
  position: sticky;
  top: 58px;
  z-index: 11;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  height: 58px;
  background: #fff;
}

.collect-tabs button {
  position: relative;
  border: 0;
  background: transparent;
  color: #4f5969;
  font-size: 14px;
  line-height: 58px;
}

.collect-tabs .active {
  color: #06152b;
  font-weight: 700;
}

.collect-tabs .active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 52px;
  height: 3px;
  border-radius: 3px;
  transform: translateX(-50%);
  background: #1e94ff;
}

.collect-main {
  padding: 12px 14px 24px;
}

.hotel-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 14px;
}

.hotel-card {
  min-width: 0;
  overflow: hidden;
  border-radius: 8px;
  background: #fff;
}

.hotel-card img {
  display: block;
  width: 100%;
  height: 118px;
  object-fit: cover;
  background: #dfe5ee;
}

.hotel-card h2 {
  height: 36px;
  margin: 7px 8px 0;
  overflow: hidden;
  color: #06152b;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
}

.hotel-card p {
  display: flex;
  align-items: baseline;
  margin: 6px 8px 9px;
  line-height: 16px;
}

.hotel-card strong {
  margin-right: 4px;
  color: #ff0b0b;
  font-size: 14px;
}

.hotel-card span {
  overflow: hidden;
  color: #9aa0ad;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shop-list {
  display: grid;
  row-gap: 10px;
}

.shop-card {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr) 20px;
  align-items: center;
  column-gap: 12px;
  min-height: 82px;
  padding: 12px;
  border-radius: 9px;
  background: #fff;
}

.shop-card img {
  width: 58px;
  height: 58px;
  border-radius: 8px;
  object-fit: cover;
  background: #eef2f7;
}

.shop-info {
  min-width: 0;
}

.shop-info h2 {
  margin: 0;
  overflow: hidden;
  color: #06152b;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.shop-info p {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 7px 0 0;
  color: #718096;
  font-size: 12px;
  line-height: 16px;
}

.shop-card > .van-icon {
  color: #06152b;
  font-size: 18px;
}

.empty-state {
  padding: 48px 20px;
  color: #a4adbb;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
}

.kefu {
  position: fixed;
  right: 15px;
  bottom: 88px;
  z-index: 80;
  width: 62px;
  height: 62px;
}

.kefu_img {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  border: 4px solid #fff;
  border-radius: 50%;
  background: linear-gradient(180deg, #1b7dff 0%, #0d80ff 64%, #fb1426 65%, #fb1426 100%);
  box-shadow: 0 6px 14px rgba(30, 70, 130, .25);
  color: #fff;
}

.kefu_img .van-icon {
  font-size: 31px;
}
</style>
